import React from 'react';;
import { Link } from 'react-router-dom';

export default (props) => {
  if(window) {
    return (
      <Link 
        to={props.to}
        role="button" 
        className={props.className}
      >
        {props.children} 
      </Link>
    );
  } else {
    return (
      <a 
        href={props.to}
        role="button" 
        className={props.className}
      >
        {props.children} 
      </a>
    );    
  }

}